import { create } from 'zustand';

type DownloadDocumentState = {
  close: () => void;
  fileLinks: string[];
  isOpen: boolean;
  open: (payload: string[]) => void;
};

export const downloadDocumentStorage = create<DownloadDocumentState>()((set) => ({
  isOpen: false,
  fileLinks: [],
  open: (payload) => {
    set({ isOpen: true, fileLinks: payload });
  },
  close: () => {
    set({ isOpen: false, fileLinks: [] });
  },
}));
